/* CYGNUSS: scripts so da pagina do produto (resumo das avaliacoes e titulo vazio das avaliacoes), antes inline no cyg-seo.liquid. */
/* ---- bloco 2 (antes inline no cyg-seo.liquid, linha 468) ---- */
try {
  /* CYG-RSUM (so na pagina do produto): monta o resumo (nota, estrelas e lista de classificacao) com os dados reais que o Judge.me deixa na pagina */
  (function () {
    function cria(d, alvo) {
      if (document.querySelector('.cyg-rsum')) return true;
      var h = d.histogram || [], n = d.number_of_reviews || 0, nota = parseFloat(d.average_rating) || 0;
      if (!n || !h.length) return true;
      var box = document.createElement('div'); box.className = 'cyg-rsum';
      var big = document.createElement('div'); big.className = 'cyg-rsum__big';
      var num = document.createElement('div'); num.className = 'cyg-rsum__nota'; num.textContent = nota.toFixed(1).replace('.', ',');
      var st = document.createElement('span'); st.className = 'cyg-rsum__stars'; st.setAttribute('role', 'img'); st.setAttribute('aria-label', 'Nota ' + nota.toFixed(1) + ' de 5');
      st.textContent = '★★★★★';
      var fg = document.createElement('span'); fg.className = 'cyg-rsum__stars-fg'; fg.setAttribute('aria-hidden', 'true'); fg.textContent = '★★★★★'; fg.style.setProperty('--w', (nota / 5 * 100) + '%'); st.appendChild(fg);
      var tot = document.createElement('div'); tot.className = 'cyg-rsum__tot'; tot.textContent = n + ' avaliações';
      big.appendChild(num); big.appendChild(st); big.appendChild(tot);
      var ul = document.createElement('ul'); ul.className = 'cyg-rsum__hist';
      h.slice().sort(function (a, b) { return b.rating - a.rating; }).forEach(function (r) {
        var li = document.createElement('li');
        var a = document.createElement('span'); a.textContent = r.rating + ' ★';
        var tr = document.createElement('span'); tr.className = 'cyg-rsum__trilho'; var f = document.createElement('span'); f.style.setProperty('--w', (r.percentage || 0) + '%'); tr.appendChild(f);
        var p = document.createElement('span'); p.textContent = (r.percentage || 0) + '%';
        li.appendChild(a); li.appendChild(tr); li.appendChild(p); ul.appendChild(li);
      });
      box.appendChild(big); box.appendChild(ul);
      /* no computador o "Escrever uma avaliacao" mora no card da nota (cyg.css, CYG-RSUM); abre o mesmo formulario do Judge.me */
      var esc = document.createElement('button'); esc.type = 'button'; esc.className = 'cyg-rsum__escrever'; esc.textContent = 'Escrever uma avaliação';
      esc.addEventListener('click', function () {
        var b = document.querySelector('#judgeme_product_reviews [data-testid="write-review-button"]');
        if (b) b.click(); else alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      box.appendChild(esc);
      alvo.parentNode.insertBefore(box, alvo);
      return true;
    }
    function tenta(vez) {
      var alvo = document.getElementById('judgeme_product_reviews');
      var w = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
      if (alvo && w) {
        var d = w[alvo.getAttribute('data-product-id')] || w[alvo.getAttribute('data-id')];
        if (d) { cria(d, alvo); return; }
      }
      if (!alvo && vez > 5) return; /* sem o bloco de avaliacoes na pagina: para de tentar */
      if (vez < 40) setTimeout(function () { tenta(vez + 1); }, 400);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tenta(0); }); else tenta(0);
  })();
} catch (e) { console.error('[cyg] bloco 2', e); }

/* ---- bloco 3 (antes inline no cyg-seo.liquid, linha 508) ---- */
try {
  /* CYG-AVAL: esconde o titulo da avaliacao quando o cliente nao escreveu nenhum (vem so aspas) */
  (function () {
    function limpa(root) {
      (root || document).querySelectorAll('#judgeme_product_reviews .jm-review-content__title').forEach(function (t) {
        if (t.textContent.replace(/[\s'"‘’“”]/g, '') === '') t.classList.add('cyg-vazio');
      });
    }
    function liga() {
      var alvo = document.getElementById('judgeme_product_reviews'); if (!alvo || alvo.dataset.cygAval) return;
      alvo.dataset.cygAval = '1'; /* liga uma vez so (antes ligava 2 observadores) */
      var q = 0; /* 13/10 velocidade: uma passada por quadro, nao uma por mudanca */
      new MutationObserver(function () { if (!q) q = requestAnimationFrame(function () { q = 0; limpa(alvo); }); }).observe(alvo, { childList: true, subtree: true });
      limpa(alvo);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga); else liga();
    setTimeout(liga, 2500);
  })();
} catch (e) { console.error('[cyg] bloco 3', e); }

/* ---- bloco 4 ---- */
try {
  /* CYG-AVAL-6: no computador a lista de avaliacoes mostra 6 por vez, 2 colunas x 3 linhas (pedido do Guifa, 12/10/2026).
     O Judge.me manda 4 por pagina em toda a loja (configuracao do app, vale tambem para o tema no ar). Aqui, so neste tema:
     a pagina 1 que vem escrita na pagina e trocada pela de 6 antes do widget ler, e as paginas seguintes pedem 6.
     A de 6 fica guardada na sessao, entao da segunda pagina de produto em diante a troca e imediata.
     Se a de 6 chegar depois do widget ler, nada muda e fica com 4, sem pular avaliacao. */
  (function () {
    if (!window.matchMedia || !window.matchMedia('(min-width: 990px)').matches || !window.fetch || !window.URL) return;
    var POR = 6;
    var alvo = document.getElementById('judgeme_product_reviews');
    var w = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
    var pid = alvo && (alvo.getAttribute('data-product-id') || alvo.getAttribute('data-id'));
    var orig = w && pid && w[pid];
    if (!orig || !orig.pagination || !orig.reviews || alvo.hasAttribute('data-v-app')) return;
    if (orig.pagination.per_page >= POR || (orig.number_of_reviews || 0) <= orig.reviews.length) return;
    /* o loader do Judge.me so confere se ha dados; quem vale e a ultima leitura, a do widget */
    var atual = orig, entregue = null, novo = null, decidido = null;
    try {
      Object.defineProperty(w, pid, { configurable: true, enumerable: true, get: function () { entregue = atual; return atual; }, set: function (v) { atual = v; } });
    } catch (e) { return; }
    function troca(d) {
      if (novo || !d || !d.reviews || !d.reviews.length || !d.pagination || d.pagination.per_page !== POR || d.pagination.current_page !== 1) return false;
      var n = {}; Object.keys(orig).forEach(function (k) { n[k] = orig[k]; });
      n.reviews = d.reviews; n.pagination = d.pagination;
      n.review_translations = Object.assign({}, orig.review_translations || {}, d.review_translations || {});
      novo = n; atual = n; return true;
    }
    var chave = 'cyg-aval6:' + pid + ':' + orig.sort_key + ':' + orig.metafield_updated_at;
    var guardado = null;
    try { guardado = JSON.parse(sessionStorage.getItem(chave) || 'null'); } catch (e) {}
    if (!troca(guardado)) {
      var s = window.jdgmSettings || {}, sh = window.Shopify || {};
      var u = new URL('https://cdn.judge.me/reviews/reviews_for_widget');
      var q = { product_id: pid, page: 1, per_page: POR, sort_by: orig.sort_key, translation_locale: sh.locale || document.documentElement.lang, widget_theme: s.review_widget_reviews_section_theme, ts: orig.metafield_updated_at, shop_domain: sh.shop, platform: s.platform || 'shopify' };
      Object.keys(q).forEach(function (k) { if (q[k] != null && q[k] !== '') u.searchParams.set(k, q[k]); });
      window.fetch(u.toString()).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        if (!troca(d)) return;
        try { sessionStorage.setItem(chave, JSON.stringify({ reviews: d.reviews, pagination: d.pagination, review_translations: d.review_translations })); } catch (e) {}
      }).catch(function () {});
    }
    /* so pede 6 nas paginas seguintes se o widget abriu com a de 6 (confere tambem quantos cartoes estao na tela) */
    function usaSeis() {
      if (decidido === null) {
        decidido = !!novo && entregue === novo && alvo.querySelectorAll('.jm-review-item').length === novo.reviews.length;
        alvo.setAttribute('data-cyg-seis', decidido ? 'sim' : 'nao');
      }
      return decidido;
    }
    var f0 = window.fetch;
    window.fetch = function (inp, init) {
      try {
        var texto = typeof inp === 'string' || inp instanceof URL;
        var url = texto ? String(inp) : inp && inp.url;
        if (url && url.indexOf('/reviews/reviews_for_widget') > -1 && url.indexOf('product_id=' + pid) > -1 && !/[?&]per_page=/.test(url) && usaSeis()) {
          var nu = url + (url.indexOf('?') > -1 ? '&' : '?') + 'per_page=' + POR;
          inp = texto ? nu : new Request(nu, inp);
        }
      } catch (e) {}
      return arguments.length > 1 ? f0.call(window, inp, init) : f0.call(window, inp);
    };
  })();
} catch (e) { console.error('[cyg] bloco 4', e); }

/* ---- bloco 5: teclado x mouse (13/10/2026) ---- */
try {
  /* contornos de foco que o navegador acende ate depois do clique do mouse (select invisivel da barra fixa de compra) so aparecem
     para quem navega pelo teclado: Tab ou setas ligam a classe, toque ou clique desliga (Mineiro #231) */
  (function () {
    var h = document.documentElement;
    document.addEventListener('keydown', function (e) { if (e.key === 'Tab' || e.key.indexOf('Arrow') === 0) h.classList.add('cyg-teclado'); }, true);
    document.addEventListener('pointerdown', function () { h.classList.remove('cyg-teclado'); }, true);
  })();
} catch (e) { console.error('[cyg] bloco 5', e); }

/* ---- bloco 6: card da nota alinhado com os cartoes de avaliacao no computador (13/10/2026) ---- */
try {
  /* pedido do Guifa: "sempre precisa estar alinhado" (#212). O topo do card fica no topo da 1a fileira de cartoes e a base na base
     da fileira mais perto de 3:4 que caiba na janela; refaz ao trocar de pagina, abrir um "Mais" ou mudar a janela (cyg.css, CYG-RSUM) */
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    var feito = false, vez = 0;
    function limpa(b) { ['--cyg-rsum-h', '--cyg-rsum-topo', '--cyg-lista-min'].forEach(function (k) { b.style.removeProperty(k); }); }
    /* altura minima do card: nota, barras e botao sem apertar (soma dos filhos, vaos e respiro) */
    function minimo(rs) {
      var cs = getComputedStyle(rs), gap = parseFloat(cs.rowGap) || 0, kids = [].filter.call(rs.children, function (k) { return k.getBoundingClientRect().height > 0; });
      var soma = kids.reduce(function (a, k) { return a + k.getBoundingClientRect().height; }, 0);
      return Math.ceil(soma + gap * Math.max(0, kids.length - 1) + (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0));
    }
    function mede() {
      var rs = document.querySelector('.shopify-app-block > .cyg-rsum'); var root = document.getElementById('judgeme_product_reviews');
      if (!rs || !root) return;
      var bloco = rs.parentElement;
      if (!mq.matches) { limpa(bloco); return; }
      var lista = root.querySelector('.jdgm-review-list');
      var itens = lista ? [].filter.call(lista.querySelectorAll('.jm-review-item'), function (i) { return i.getBoundingClientRect().width > 0; }) : [];
      if (!itens.length) { limpa(bloco); return; }
      var lt = lista.getBoundingClientRect().top;
      var bases = [];
      itens.forEach(function (i) {
        var r = i.getBoundingClientRect(), t = r.top - lt;
        var f = bases.filter(function (x) { return Math.abs(x.t - t) < 3; })[0];
        if (f) f.b = Math.max(f.b, r.bottom - lt); else bases.push({ t: t, b: r.bottom - lt });
      });
      var hd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 66;
      var maxH = window.innerHeight - hd - 48, min = minimo(rs);
      /* 13/10 tarde ("o UI aqui ta quebrado", pagina com 4 avaliacoes): o card vai da 1a a ultima fileira que caiba na janela;
         se as fileiras somam menos que o minimo do card, as fileiras crescem por igual ate o minimo, e topo e base seguem alinhados */
      /* o minimo vale sempre (lista mais alta nao muda; mais baixa estica), assim a medida nao oscila */
      bloco.style.setProperty('--cyg-lista-min', min + 'px');
      var ultima = bases[bases.length - 1].b, h;
      if (ultima < min - 1) h = min;
      else {
        var cand = bases.map(function (f) { return f.b; }).filter(function (b) { return b >= min - 1 && b <= maxH; });
        h = cand.length ? cand[cand.length - 1] : min;
      }
      bloco.style.setProperty('--cyg-rsum-topo', Math.round((lt - bloco.getBoundingClientRect().top) * 10) / 10 + 'px');
      bloco.style.setProperty('--cyg-rsum-h', Math.round(h * 10) / 10 + 'px');
    }
    var pendente = false;
    function agenda() { if (pendente) return; pendente = true; requestAnimationFrame(function () { pendente = false; mede(); }); }
    function liga() {
      var rs = document.querySelector('.shopify-app-block > .cyg-rsum'), root = document.getElementById('judgeme_product_reviews');
      if (!rs || !root) { if (vez++ < 40) setTimeout(liga, 500); return; }
      if (feito) return; feito = true;
      /* 13/10 velocidade: so mede quando as avaliacoes chegam perto da tela (medir na carga forcava layout da pagina inteira) */
      var comeca = function () {
        if (window.ResizeObserver) new ResizeObserver(agenda).observe(root);
        window.addEventListener('resize', agenda);
        if (mq.addEventListener) mq.addEventListener('change', agenda);
        agenda();
      };
      if (!window.IntersectionObserver) return comeca();
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); comeca(); } }, { rootMargin: '800px 0px' });
      io.observe(root);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga); else liga();
  })();
} catch (e) { console.error('[cyg] bloco 6', e); }

/* ---- bloco 7: texto do 1o cartao de "Feita com qualidade" no meio do cartao (13/10/2026) ---- */
try {
  /* o cartao creme tem a altura das fotos (3:4); o respiro de cima = (altura do cartao - titulo - texto) / 2 (cyg.css, 8i-PC) */
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    function mede() {
      var w = document.querySelector('[id$="__quality_cyg"] .section-content-wrapper');
      if (!w) return;
      if (!mq.matches) { w.style.removeProperty('--cyg-q-pad'); return; }
      var t = w.querySelector(':scope > .text-block:not(.rte)'), r = w.querySelector(':scope > .rte'), img = w.querySelector(':scope > .group-block img');
      if (!t || !img) return;
      var H = img.getBoundingClientRect().height; if (!H) return;
      var pt = parseFloat(getComputedStyle(t).paddingTop) || 0;
      var T = t.getBoundingClientRect().height - pt + (r ? r.getBoundingClientRect().height : 0);
      w.style.setProperty('--cyg-q-pad', Math.max(16, Math.round((H - T) / 2)) + 'px');
    }
    var pendente = false;
    function agenda() { if (pendente) return; pendente = true; requestAnimationFrame(function () { pendente = false; mede(); }); }
    function liga() {
      var w = document.querySelector('[id$="__quality_cyg"] .section-content-wrapper');
      if (!w) return;
      var comeca = function () {
        if (window.ResizeObserver) new ResizeObserver(agenda).observe(w);
        window.addEventListener('resize', agenda);
        [].forEach.call(w.querySelectorAll('img'), function (i) { if (!i.complete) i.addEventListener('load', agenda, { once: true }); });
        agenda();
      };
      /* 13/10 velocidade: mede so perto da tela */
      if (!window.IntersectionObserver) return comeca();
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); comeca(); } }, { rootMargin: '800px 0px' });
      io.observe(w);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga); else liga();
  })();
} catch (e) { console.error('[cyg] bloco 7', e); }

/* ---- bloco 8: galeria em pares no computador, foto e miniatura no mesmo estado (13/10/2026) ---- */
try {
  /* pedido do Guifa: "nao pula de 2 em 2 imagens, e ta intercalando entre a mudanca de imagem e a mudanca das thumbnails,
     deveriam ser conectadas". Um estado so: o current do slideshow. Miniatura impar leva ao par dela (indice par) e as 2
     miniaturas do par visivel ficam marcadas juntas, no mesmo evento de troca (#209, #228) */
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    function galeria() { return document.querySelector('[id$="__main"] .media-gallery--carousel slideshow-component'); }
    function marca(sl) {
      var th = sl.querySelectorAll('.slideshow-controls__thumbnail'), cur = sl.current || 0;
      for (var i = 0; i < th.length; i++) th[i].classList.toggle('cyg-par', mq.matches && i === cur + 1 && cur % 2 === 0);
    }
    function liga() {
      var sl = galeria();
      if (!sl) return;
      sl.addEventListener('slideshow:select', function () { marca(sl); });
      /* clique numa miniatura impar no computador: vai para o inicio do par, antes do tema tratar o clique */
      sl.addEventListener('click', function (e) {
        if (!mq.matches) return;
        var b = e.target.closest('.slideshow-controls__thumbnail');
        if (!b) return;
        var th = [].indexOf.call(sl.querySelectorAll('.slideshow-controls__thumbnail'), b);
        if (th < 0 || th % 2 === 0) return;
        e.preventDefault(); e.stopImmediatePropagation();
        sl.select(th - 1, e);
      }, true);
      mq.addEventListener && mq.addEventListener('change', function () { marca(sl); });
      marca(sl);
      /* fluidez no computador (13/10: "quando passa a imagem pro lado nao parece fluido e suave"). Causa medida: cada troca grava
         aria-hidden/aria-selected e le a posicao no mesmo clique, e a pagina recalcula o estilo de ~1.400 elementos antes e durante o
         movimento (UpdateLayoutTree ~110 ms com CPU normal, ~450 ms com CPU 4x); o rolar suave do navegador espera esse trabalho e
         vira solavancos. Aqui a troca vai instantanea e o movimento e uma animacao de transform (compositor, nao depende da thread
         principal), com a mesma curva para seta, miniatura e teclado; fotos dos pares vizinhos baixam e decodificam antes */
      var orig = sl.select, anims = [], movendo = false;
      var reduz = window.matchMedia('(prefers-reduced-motion: reduce)');
      function elas(sel) { return [].slice.call(sl.querySelectorAll(sel)); }
      function deslocado(el) {
        try { var m = getComputedStyle(el).transform; return m && m !== 'none' ? new DOMMatrix(m) : { m41: 0, m42: 0 }; } catch (e) { return { m41: 0, m42: 0 }; }
      }
      /* vizinhos prontos sem mexer no DOM no caminho do clique: a carga das fotos adiante e feita uma vez, ociosa; depois de cada troca so decodifica (decode() nao grava atributo) */
      function prepara(a, b, soDecode) {
        var im = elas('slideshow-slide img'), lo = Math.max(0, Math.min(a, b) - 2), hi = Math.min(im.length - 1, Math.max(a, b) + 5);
        for (var i = lo; i <= hi; i++) { if (!soDecode && im[i].loading === 'lazy') im[i].loading = 'eager'; if (im[i].decode) im[i].decode().catch(function () {}); }
      }
      if (typeof orig === 'function') {
        sl.select = function (i, ev, opt) {
          var tr = sl.querySelector('slideshow-slides'), box = sl.querySelector('.slideshow-controls__thumbnails-container');
          if (!mq.matches || reduz.matches || !tr || !sl.animate || (opt && opt.animate === false)) return orig.apply(sl, arguments);
          var slides = sl.slides || elas('slideshow-slide'), de = sl.current || 0, ref = slides[de];
          var vx = ref ? deslocado(ref).m41 : 0, th = elas('.slideshow-controls__thumbnail'), vy = th[0] ? deslocado(th[0]).m42 : 0;
          anims.forEach(function (x) { x.cancel(); }); anims = [];
          var x0 = tr.scrollLeft, y0 = box ? box.scrollTop : 0;
          movendo = true; clearTimeout(sl.__cygMov); sl.__cygMov = setTimeout(function () { movendo = false; }, 460);
          var args = [].slice.call(arguments); args[2] = Object.assign({}, opt, { animate: false });
          /* destino anotado na chamada de rolagem do proprio tema: ler a posicao depois das gravacoes forcaria mais um recalculo da pagina no clique */
          var maxX = tr.scrollWidth - tr.clientWidth, maxY = box ? box.scrollHeight - box.clientHeight : 0, reg = {}, r;
          tr.scrollTo = function (o) { if (o && typeof o.left === 'number') reg.x = o.left; return Element.prototype.scrollTo.apply(this, arguments); };
          if (box) box.scrollTo = function (o) { if (o && typeof o.top === 'number') reg.y = o.top; return Element.prototype.scrollTo.apply(this, arguments); };
          try { r = orig.apply(sl, args); } finally { delete tr.scrollTo; if (box) delete box.scrollTo; }
          var x1 = reg.x != null ? Math.max(0, Math.min(reg.x, maxX)) : x0, y1 = reg.y != null ? Math.max(0, Math.min(reg.y, maxY)) : y0, para = sl.current || 0;
          var dx = x1 - x0 + vx, dy = y1 - y0 + vy;
          var lo = Math.max(0, Math.min(de, para) - 1), hi = Math.min(slides.length - 1, Math.max(de, para) + 3);
          var cfg = { duration: 340, easing: 'cubic-bezier(.22,.61,.36,1)' };
          if (dx) for (var s = lo; s <= hi; s++) anims.push(slides[s].animate([{ transform: 'translateX(' + dx + 'px)' }, { transform: 'translateX(0)' }], cfg));
          if (dy) th.slice(Math.max(0, Math.min(de, para) - 2), Math.max(de, para) + 8).forEach(function (t) { anims.push(t.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'translateY(0)' }], cfg)); });
          (window.requestIdleCallback || setTimeout)(function () { prepara(para, para, true); }, { timeout: 900 });
          return r;
        };
        /* encaixe automatico desligado no computador (a animacao de transform muda a posicao de encaixe das fotos e o navegador reencaixava no par errado);
           ao fim de um arrastar com o trackpad, a galeria se acomoda no inicio do par mais perto, com a mesma animacao */
        var tempo;
        function acomoda() {
          var tr = sl.querySelector('slideshow-slides'), sls = sl.slides || elas('slideshow-slide');
          if (movendo || !mq.matches || reduz.matches || !tr || !sls[2] || !sl.animate) return;
          var passo = sls[2].offsetLeft, x = tr.scrollLeft; if (!passo) return;
          var par = Math.round(x / passo), alvo = Math.min(par * passo, tr.scrollWidth - tr.clientWidth); alvo = Math.max(0, alvo);
          var idx = Math.min(sls.length - 1, par * 2);
          if (sl.current !== idx) { sl.current = idx; marca(sl); } /* o arrastar do tema deixava o indice impar: foto e miniaturas voltam ao inicio do par */
          if (Math.abs(x - alvo) < 2) return;
          anims.forEach(function (a) { a.cancel(); }); anims = [];
          tr.scrollTo({ left: alvo, behavior: 'instant' });
          var lo = Math.max(0, Math.floor(Math.min(x, alvo) / passo) * 2 - 1), hi = Math.min(sls.length - 1, Math.ceil(Math.max(x, alvo) / passo) * 2 + 3);
          for (var k = lo; k <= hi; k++) anims.push(sls[k].animate([{ transform: 'translateX(' + (alvo - x) + 'px)' }, { transform: 'translateX(0)' }], { duration: 260, easing: 'cubic-bezier(.22,.61,.36,1)' }));
        }
        var trilho = sl.querySelector('slideshow-slides');
        if (trilho) {
          if ('onscrollend' in window) trilho.addEventListener('scrollend', function () { if (mq.matches) acomoda(); });
          else trilho.addEventListener('scroll', function () { clearTimeout(tempo); tempo = setTimeout(acomoda, 160); }, { passive: true });
        }
        /* pares vizinhos prontos: depois da carga, com a pagina ociosa */
        (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () { if (mq.matches) prepara(0, 3); }, { timeout: 4000 });
      }
      /* celular (13/10: "toda vez que eu passo uma imagem, a thumbnail deveria passar junto"): o tema so trocava a miniatura quando a
         rolagem parava (~0,7 s depois). Durante o deslize, a foto mais perto do centro vira o current do proprio slideshow (mesmo estado,
         que marca a miniatura) e a fileira de miniaturas rola so ela, sem puxar a pagina */
      var cont = sl.querySelector('slideshow-slides') || sl.querySelector('slideshow-container');
      var quadro = 0;
      function vivo() {
        quadro = 0;
        if (mq.matches || !cont) return;
        var cr = cont.getBoundingClientRect(), meio = cr.left + cr.width / 2, best = -1, dist = 1e9;
        var slides = sl.slides || [].slice.call(sl.querySelectorAll('slideshow-slide'));
        for (var i = 0; i < slides.length; i++) {
          var r = slides[i].getBoundingClientRect(); if (!r.width) continue;
          var d = Math.abs(r.left + r.width / 2 - meio); if (d < dist) { dist = d; best = i; }
        }
        if (best < 0 || best === sl.current) return;
        sl.current = best;
        var ths = sl.querySelectorAll('.slideshow-controls__thumbnail'), t = ths[best], box = sl.querySelector('.slideshow-controls__thumbnails-container');
        if (t && box) {
          var tr = t.getBoundingClientRect(), br = box.getBoundingClientRect();
          box.scrollTo({ left: box.scrollLeft + (tr.left + tr.width / 2) - (br.left + br.width / 2), behavior: 'smooth' });
        }
      }
      if (cont) cont.addEventListener('scroll', function () { if (!quadro) quadro = requestAnimationFrame(vivo); }, { passive: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga); else liga();
  })();
} catch (e) { console.error('[cyg] bloco 8', e); }
